import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { InsightsState, Option } from "lib/types/state"
import dayjs from "dayjs"

const initialState: InsightsState = {
  filteredDays: 1,
  startDate: dayjs().startOf("day").format("YYYY-MM-DDTHH:mm"),
  endDate: dayjs().format("YYYY-MM-DDTHH:mm"),
  selectedStoreGroups: [],
  selectedStoreMarkets: [],
  selectedReasons: [],
  numberOfHits: "25",
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
}

export const slice = createSlice({
  name: "insights",
  initialState: { ...initialState },
  reducers: {
    setFilteredDays(state, action: PayloadAction<number>) {
      state.filteredDays = action.payload
    },
    setStartDate(state, action: PayloadAction<string>) {
      state.startDate = action.payload
    },
    setEndDate(state, action: PayloadAction<string>) {
      state.endDate = action.payload
    },
    setSelectedStoreGroups(state, action: PayloadAction<Option[]>) {
      state.selectedStoreGroups = action.payload
    },
    setSelectedStoreMarkets(state, action: PayloadAction<Option[]>) {
      state.selectedStoreMarkets = action.payload
    },
    setSelectedReasons(state, action: PayloadAction<Option[]>) {
      state.selectedReasons = action.payload
    },
    setNumberOfHits(state, action: PayloadAction<string>) {
      state.numberOfHits = action.payload
    },
    setTimeZone(state, action: PayloadAction<string>) {
      state.timeZone = action.payload
    }
  }
})

const { actions, reducer } = slice
export const {
  setFilteredDays,
  setStartDate,
  setEndDate,
  setSelectedStoreGroups,
  setSelectedStoreMarkets,
  setSelectedReasons,
  setNumberOfHits,
  setTimeZone
} = actions

export default reducer
